import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "mp3container"
}
const _hoisted_4 = { class: "mp3container_left" }
const _hoisted_5 = { class: "mp3container_right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_library_filter_view = _resolveComponent("library-filter-view")!
  const _component_library_album = _resolveComponent("library-album")!
  const _component_audio_player = _resolveComponent("audio-player")!

  return (_openBlock(), _createElementBlock("div", {
    class: "mp3player",
    style: _normalizeStyle(_ctx.cursorLoading? 'cursor: wait' : 'cursor: auto')
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("p", null, _toDisplayString(_ctx.info), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "desktop-mp3filters",
              style: _normalizeStyle(_ctx.styleObjectFilters)
            }, [
              _createVNode(_component_library_filter_view, {
                filter: _ctx.yearFilter,
                "filter-name-prop": 'year',
                onSelectValue: _ctx.selectValueFilter,
                onAddValue: _ctx.addValueFilter
              }, null, 8, ["filter", "onSelectValue", "onAddValue"]),
              _createVNode(_component_library_filter_view, {
                filter: _ctx.artistsFilter,
                "filter-name-prop": 'artist',
                onSelectValue: _ctx.selectValueFilter,
                onAddValue: _ctx.addValueFilter
              }, null, 8, ["filter", "onSelectValue", "onAddValue"]),
              _createVNode(_component_library_filter_view, {
                filter: _ctx.genresFilter,
                "filter-name-prop": 'genre',
                onSelectValue: _ctx.selectValueFilter,
                onAddValue: _ctx.addValueFilter
              }, null, 8, ["filter", "onSelectValue", "onAddValue"]),
              _createVNode(_component_library_filter_view, {
                filter: _ctx.ratingsFilter,
                "filter-name-prop": 'rating',
                onSelectValue: _ctx.selectValueFilter,
                onAddValue: _ctx.addValueFilter
              }, null, 8, ["filter", "onSelectValue", "onAddValue"])
            ], 4),
            (_ctx.albums.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "mp3library",
                  style: _normalizeStyle(_ctx.styleObjectLibrary)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albums, (album) => {
                    return (_openBlock(), _createBlock(_component_library_album, {
                      key: album.id,
                      album: album,
                      onAddToPlaylist: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addToPlaylist()))
                    }, null, 8, ["album"]))
                  }), 128))
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_audio_player, {
              playList: _ctx.audioList,
              albumId: _ctx.albumId,
              onClearPlaylist: _ctx.clearPlaylist,
              onChangeTrack: _ctx.changeTrack,
              onGift: _ctx.gift,
              onAddAll: _ctx.addAll
            }, null, 8, ["playList", "albumId", "onClearPlaylist", "onChangeTrack", "onGift", "onAddAll"])
          ])
        ]))
  ], 4))
}